import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDemoinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M10 21.004H4.996a2 2 0 0 1-2-2.001V4.997a2 2 0 0 1 2-2h14.006a2 2 0 0 1 2 2V10M2.996 7.998h18.008" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.004 17.002a5 5 0 0 1-5.002 5.002v0A5 5 0 0 1 12 17.002v0A5 5 0 0 1 17.002 12v0a5 5 0 0 1 5.002 5.002",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m16.283 15.003 2.637 1.56a.51.51 0 0 1 0 .877L16.283 19a.51.51 0 0 1-.77-.44v-3.118c0-.395.43-.64.77-.439",
				clipRule: "evenodd"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h24v24H0z"
		})
	}) })]
});
export default SvgDemoinline;
